
import store from '../../config/store'

export default {
  props: {
    avis: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    store
  }),

  computed: {
    account () {
      return store.data.user.account
    }
  },

  methods: {

    downloadStatement (url) {
      url = url.replace('http://', 'https://')
      this.downloadFileFromUrl(url)
    }
  }
}
